// ColoredTiles render at a 110px logical cell. Keep in sync with CELL_SIZE in
// LinearPiece.tsx and WORKSPACE_CELL_SIZE in ColoredTiles.tsx.
var CELL = 110;
/**
 * Exact center a linear piece occupies when snapped to a tile's edge slot.
 * This is the inverse of `resolveSnapSlot` in LinearPiece.tsx — placing a piece
 * at this center makes `commitMove`'s re-detection resolve back to (tile, side,
 * slot) within its ±5px halo. The 22/21 perpendicular offsets and the
 * `slot*cell + cell/2` along-edge position mirror that function exactly.
 */
export var getEdgeSlotCenter = function (tile, side, slot) {
    var _a;
    var scale = (_a = tile.scale) !== null && _a !== void 0 ? _a : 1;
    var scaledCell = CELL * scale;
    var w = tile.columns * scaledCell;
    var h = tile.rows * scaledCell;
    var tLeft = tile.center.x - w / 2;
    var tRight = tile.center.x + w / 2;
    var tTop = tile.center.y - h / 2;
    var tBottom = tile.center.y + h / 2;
    switch (side) {
        case 'left':
            return { x: tLeft - 22 * scale, y: tTop + slot * scaledCell + scaledCell / 2 };
        case 'right':
            return { x: tRight + 22 * scale, y: tTop + slot * scaledCell + scaledCell / 2 };
        case 'top':
            return { x: tLeft + slot * scaledCell + scaledCell / 2, y: tTop - 21 * scale };
        case 'bottom':
        default:
            return { x: tLeft + slot * scaledCell + scaledCell / 2, y: tBottom + 21 * scale };
    }
};
/**
 * Every FREE edge slot on `tile` compatible with the piece's orientation
 * (vertical → left/right rows, horizontal → top/bottom columns). A slot is free
 * only when its `snapped*PieceIds[slot]` is empty — a piece's own currently
 * occupied slot is therefore NOT offered (the picker moves a piece to a
 * *different* slot, so re-offering its own slot is a confusing no-op).
 */
export var listFreeSnapSlots = function (tile, orientation) {
    var _a, _b, _c, _d;
    var slots = [];
    var isFree = function (occupant) { return !occupant; };
    if (orientation === 'vertical') {
        var left = (_a = tile.snappedVerticalPieceIds) !== null && _a !== void 0 ? _a : Array(tile.rows).fill(null);
        var right = (_b = tile.snappedRightVerticalPieceIds) !== null && _b !== void 0 ? _b : Array(tile.rows).fill(null);
        for (var r = 0; r < tile.rows; r++) {
            if (isFree(left[r]))
                slots.push({ side: 'left', slot: r, center: getEdgeSlotCenter(tile, 'left', r) });
            if (isFree(right[r]))
                slots.push({ side: 'right', slot: r, center: getEdgeSlotCenter(tile, 'right', r) });
        }
    }
    else {
        var top_1 = (_c = tile.snappedHorizontalPieceIds) !== null && _c !== void 0 ? _c : Array(tile.columns).fill(null);
        var bottom = (_d = tile.snappedBottomHorizontalPieceIds) !== null && _d !== void 0 ? _d : Array(tile.columns).fill(null);
        for (var c = 0; c < tile.columns; c++) {
            if (isFree(top_1[c]))
                slots.push({ side: 'top', slot: c, center: getEdgeSlotCenter(tile, 'top', c) });
            if (isFree(bottom[c]))
                slots.push({ side: 'bottom', slot: c, center: getEdgeSlotCenter(tile, 'bottom', c) });
        }
    }
    return slots;
};
